import { setFocusById } from '../../commons/query';

const inputOrder = [
  'email',
  'password',
  'cpf',
  'name',
  'birthday',
  'gender',
  'cnpj',
  'companyName',
  'responsible',
  'taxInfo',
  'stateRegistry',
  'phone'
];

const getFirstError = errorsList =>
  inputOrder.reduce((acc, input) => {
    return !acc && errorsList[input] ? input : acc;
  }, false);

const moveToFirstError = errorsList => {
  if (errorsList && typeof errorsList === 'object') {
    setFocusById(getFirstError(errorsList));
  }
};

export default moveToFirstError;
